import React from "react";

// "Someone is ready to use your gift": the session the recipient booked and
// the purchaser's Pay now button. `payment` is the pending_payment block from
// the My Gifts API; Pay now opens the same pay page the email links to (a full
// page load: /gift-pay lives in the public route tree).
export default function GiftPaymentDue({ payment, compact }) {
  if (!payment) return null;

  return (
    <section className={`vsr-card vsr-pay-due ${compact ? "is-compact" : ""}`} aria-label="Payment needed">
      <div className="vsr-pay-due-main">
        <span className="vsr-pay-due-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="9" />
            <polyline points="12 7 12 12 15 14" />
          </svg>
        </span>
        <div className="vsr-pay-due-body">
          <p className="vsr-pay-due-eyebrow">Payment needed</p>
          <h2 className="vsr-pay-due-title">Someone is ready to use your gift</h2>
          <p className="vsr-pay-due-session">
            <b>{payment.medium_name}</b>
            {payment.service_name ? ` · ${payment.service_name}` : ""}
            {payment.duration ? ` — ${payment.duration} min` : ""}
          </p>
          <p className="vsr-muted">
            {payment.date} at {payment.time}
            {payment.timezone ? ` (${payment.timezone})` : ""}
          </p>
          {!compact && payment.recipient_email && (
            <p className="vsr-muted">
              Requested by <b>{payment.recipient_email}</b>
            </p>
          )}
        </div>
      </div>
      <div className="vsr-pay-due-side">
        <p className="vsr-pay-due-amount">
          {payment.currency} {payment.price}
        </p>
        <p className="vsr-pay-due-deadline">Pay by {payment.pay_by}</p>
        <a className="vsr-btn" href={payment.pay_url}>
          Pay now
        </a>
      </div>
    </section>
  );
}
